import { useEffect, useState } from "react";
import { getMeteoData } from "../api/meteo";

export const useGetMeteoWindDirection = ({ meteoId, start, end }) => {
    const [observations, setObservations] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

  useEffect(() => {
    const fetchWindDirection = async () => {
      try {
        const result = await getMeteoData({
          meteoId,
          start,
          end,
          parameter: "windDirection"
        });

        

        setObservations(result);
      } catch (error) {
        setError(error);
        console.error("Error al obtener direcciones de viento de la meteo:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchWindDirection();
  }, [meteoId, start, end]);

  return { observations, loading, error };
};
